'use client';
import { LicenseInfo } from '@mui/x-license';

/* since this repo is private, and the value is not specific to an environment, we can commit this to source
This is license key is good for two developers */
LicenseInfo.setLicenseKey(
	'933766106aef62f583d7c28975c8dc90Tz0xMzM3MjAsRT0xODIzMjEyNzk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMS0yMDI2LFE9MixBVD1tdWx0aSxLVj0y'
);

export default function MuiXLicense() {
	return null;
}
